import React from 'react';
import logo from '../../assets/BoisLogo.png';
import { Link, useHistory } from 'react-router-dom';
import { useProductsContext } from '../../context/products_context';
import { useFilterContext } from '../../context/filter_context';
import { FaTimes, FaHome, FaInfoCircle, FaShoppingBag, FaCreditCard, FaClipboardList, FaChevronRight } from 'react-icons/fa';
import SidebarContainer from './styles';
import { useUserContext } from '../../context/user_context';
import { useLanguageContext } from '../../context/language_context';
import { getUniqueValues } from '../../utils/helpers';

const Sidebar = () => {
  const { currentUser } = useUserContext();
  const { isSidebarOpen, closeSidebar, products } = useProductsContext();
  const { setCategoryFilter } = useFilterContext();
  const { t, isArabic } = useLanguageContext();
  const history = useHistory();

  // Get unique categories from products
  const categories = getUniqueValues(products, 'category').filter(cat => cat !== 'all');

  const handleCategoryClick = (category) => {
    setCategoryFilter(category);
    closeSidebar();
    history.push('/products');
  };

  return (
    <SidebarContainer className={isArabic ? 'rtl' : ''}>
      <aside
        className={`${isSidebarOpen ? 'sidebar show-sidebar' : 'sidebar'}`}
      >
        <div className='sidebar-header'>
          <img src={logo} alt='Art & Bois' />
          <button type='button' className='close-btn' onClick={closeSidebar}>
            <FaTimes />
          </button>
        </div>

        {/* Main Navigation */}
        <div className='nav-section'>
          <h4 className='section-title'>{t.nav.menu || 'Menu'}</h4>
          <ul className='links'>
            <li>
              <Link to='/' onClick={closeSidebar}>
                <span className='link-icon'><FaHome /></span>
                <span className='link-text'>{t.nav.home}</span>
                <FaChevronRight className='chevron' />
              </Link>
            </li>
            <li>
              <Link to='/about' onClick={closeSidebar}>
                <span className='link-icon'><FaInfoCircle /></span>
                <span className='link-text'>{t.nav.about}</span>
                <FaChevronRight className='chevron' />
              </Link>
            </li>
            <li>
              <Link to='/products' onClick={closeSidebar}>
                <span className='link-icon'><FaShoppingBag /></span>
                <span className='link-text'>{t.nav.products}</span>
                <FaChevronRight className='chevron' />
              </Link>
            </li>
            {currentUser && (
              <li>
                <Link to='/checkout' onClick={closeSidebar}>
                  <span className='link-icon'><FaCreditCard /></span>
                  <span className='link-text'>{t.nav.checkout}</span>
                  <FaChevronRight className='chevron' />
                </Link>
              </li>
            )}
            {currentUser && (
              <li>
                <Link to='/orders' onClick={closeSidebar}>
                  <span className='link-icon'><FaClipboardList /></span>
                  <span className='link-text'>{t.nav.orders}</span>
                  <FaChevronRight className='chevron' />
                </Link>
              </li>
            )}
          </ul>
        </div>

        {/* Categories Section */}
        {categories.length > 0 && (
          <div className='nav-section categories-section'>
            <h4 className='section-title'>{t.filters?.category || 'Categories'}</h4>
            <ul className='categories-list'>
              {categories.map((category, index) => (
                <li key={index}>
                  <button
                    type='button'
                    className='category-btn'
                    onClick={() => handleCategoryClick(category)}
                  >
                    <span className='category-name'>{category}</span>
                    <FaChevronRight className='chevron' />
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </aside>
    </SidebarContainer>
  );
};

export default Sidebar;
